import React, { useEffect, useState, useCallback } from 'react';
import { useAdminAuth } from '../AdminAuthContext';

const ContactsPage = () => {
  const { authFetch } = useAdminAuth();
  const [contacts, setContacts] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [expanded, setExpanded] = useState(null);

  const fetchContacts = useCallback(() => {
    authFetch(`/api/contacts?page=${page}&limit=20`)
      .then(r => r.json())
      .then(data => { setContacts(data.data); setTotal(data.total); })
      .catch(() => {});
  }, [authFetch, page]);

  useEffect(() => { fetchContacts(); }, [fetchContacts]);

  const totalPages = Math.ceil(total / 20);

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-900 mb-6">
        Contatos <span className="text-gray-400 font-normal text-base">({total})</span>
      </h2>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-100">
            <tr>
              <th className="text-left px-4 py-3 font-semibold text-gray-600">Nome</th>
              <th className="text-left px-4 py-3 font-semibold text-gray-600">Email</th>
              <th className="text-left px-4 py-3 font-semibold text-gray-600">Mensagem</th>
              <th className="text-left px-4 py-3 font-semibold text-gray-600">Data</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {contacts.length === 0 && (
              <tr><td colSpan={4} className="text-center py-10 text-gray-400">Nenhum contato recebido.</td></tr>
            )}
            {contacts.map(c => (
              <React.Fragment key={c.id}>
                <tr
                  className="hover:bg-gray-50 cursor-pointer"
                  onClick={() => setExpanded(expanded === c.id ? null : c.id)}
                >
                  <td className="px-4 py-3 font-medium text-gray-800">{c.name}</td>
                  <td className="px-4 py-3">
                    <a href={`mailto:${c.email}`} className="text-blue-600 hover:underline" onClick={e => e.stopPropagation()}>
                      {c.email}
                    </a>
                  </td>
                  <td className="px-4 py-3 text-gray-500 max-w-xs truncate">{c.message}</td>
                  <td className="px-4 py-3 text-gray-500">
                    {new Date(c.created_at).toLocaleDateString('pt-BR')}
                  </td>
                </tr>
                {expanded === c.id && (
                  <tr className="bg-blue-50">
                    <td colSpan={4} className="px-4 py-4">
                      <p className="text-gray-700 whitespace-pre-wrap text-sm">{c.message}</p>
                      <a
                        href={`mailto:${c.email}?subject=Re: Contato via Nexus`}
                        className="inline-block mt-3 text-xs font-semibold text-blue-600 bg-blue-100 px-3 py-1.5 rounded-full hover:bg-blue-200"
                      >
                        Responder por email
                      </a>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-4">
          <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
            className="px-3 py-1.5 rounded-lg border border-gray-200 text-sm disabled:opacity-40 hover:bg-gray-50">←</button>
          <span className="px-3 py-1.5 text-sm text-gray-600">{page} / {totalPages}</span>
          <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
            className="px-3 py-1.5 rounded-lg border border-gray-200 text-sm disabled:opacity-40 hover:bg-gray-50">→</button>
        </div>
      )}
    </div>
  );
};

export default ContactsPage;
